import styled from 'styled-components';

export const Circle = styled('div')`
    position: absolute;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    background-color: transparent;
    border-radius: ${props => props.size/2}px;
    border: 10px solid ${props => props.color};
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
`;

export const FilledCircle = styled(Circle)`
    background-color: ${props => props.color};
`;

export const HalfCircle = styled(Circle)`
    height: ${props => props.size/2}px;  
    border-radius: 0px;
    border-top-left-radius: ${props => props.size/2}px;
    border-top-right-radius: ${props => props.size/2}px;
    border-bottom: 0px;
`

export const FilledHalfCircle = styled(HalfCircle)`
    background-color: ${props => props.color};
`
